<template>
  <div>review points</div>
</template>

<script>
export default {

}
</script>

<style>

</style>